import { GameState } from '../types/types';
import { GetStatisticsResponse } from './api';

const GAME_KEY = 'wormle-game'; // versioned key for clarity

export interface SavedGame {
  gameDate: string;
  gameState: GameState;
  startDate: number;
}

export interface SavedStats {
  gameDate: string;
  postStatisticResponse: GetStatisticsResponse;
  secondsToComplete: number;
  hintsUsed: number;
}

// --- GAME PERSISTENCE ---
export function saveGameToLocalStorage(
  gameDate: string,
  gameState: GameState,
  startDate: number,
) {
  const savedGame: SavedGame = { gameDate, gameState, startDate };
  localStorage.setItem(GAME_KEY, JSON.stringify(savedGame));
}

export function loadGameFromLocalStorage(): SavedGame | null {
  const data = localStorage.getItem(GAME_KEY);
  return data ? (JSON.parse(data) as SavedGame) : null;
}

// --- STATISTICS PERSISTENCE ---
export function saveStatsToLocalStorage(
  gameDate: string,
  postStatisticResponse: GetStatisticsResponse,
  secondsToComplete: number,
  hintsUsed: number,
) {
  const savedStats: SavedStats = {
    gameDate,
    postStatisticResponse,
    secondsToComplete,
    hintsUsed,
  };
  localStorage.setItem(`${GAME_KEY}-stats`, JSON.stringify(savedStats));
}

export function loadStatsFromLocalStorage(): SavedStats | null {
  const data = localStorage.getItem(`${GAME_KEY}-stats`);
  return data ? (JSON.parse(data) as SavedStats) : null;
}
